module.exports = __webpack_public_path__ + "static/media/SathwikRai1.47fea49d.svg";